export const retouchWPText=(txt)=> {
  let text = txt && txt.replace(/<img /g, '<img onerror="this.remove()" ');
  text = text && text.replace(/\/\/towershibuya.jp\/wp\/wp-content\/uploads\//g, '//s3.ap-northeast-1.amazonaws.com/uploads.wp-content.cms.towershibuya.jp/wp/wp-content/uploads/');
  text = contentFix(text);
  //iframeの埋め込みを外し、srcだけを取り出してreact-iframeで別に表示させるために分離
  return regexCheck(text);
}

const contentFix=(txt)=> {
  const br_replaced_txt = txt && txt.replace("\n", '<br/>' );
  const parts = br_replaced_txt && br_replaced_txt.split("\r");
  const taggedParts = parts && parts.map(part => `<p}>${part}</p>`);
  return taggedParts && taggedParts.join("");
}

const regexCheck=(txt)=> {
  const iframe_src_regex = /<iframe[^>]*[\s\S]* src=["|']([^!"']+)["|']*.*(?:\/>|.*?<\/iframe>)/;
  const iframe_match = txt && txt.match(iframe_src_regex);
  const iframe_omit_regex = new RegExp( `<iframe[^>]*[\\s\\S]* src=["|']([^!"']+)["|']*.*?:\\/>|.*?<\\/iframe>`, 'g');
  const retouched = txt && txt.replace( iframe_omit_regex, '' );
  const iframe = iframe_match && iframe_match.length>1 && iframe_match[1];
  if(iframe) console.log(iframe);
  return { retouched, iframe }
}

